module.exports = __webpack_public_path__ + "static/img/video-logo.8bf27a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video-logo.png
// module id = IKLk
// module chunks = 1